import { useContext } from 'react';
import { FilterContext } from '#advertList/components/filter/contexts/FilterContext';
import { FilterContextType } from '#advertList/components/filter/contexts/FilterContextType';

const useFilterContext = () => useContext<FilterContextType>(FilterContext);

export { useFilterContext };
